const printBtn = document.querySelector(".single-news__print")

printBtn && printBtn.addEventListener("click", () => {
    window.print()
})